import { useEffect, useRef } from 'react';

/**
 * Runs `callback` every `intervalMs`, skipping ticks while the tab is hidden
 * (same pattern as the Shop Changelog poll loop). The callback is kept in a
 * ref so the interval never has to be re-subscribed when it changes identity.
 */
export const useVisiblePolling = (callback: () => void, intervalMs: number) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const id = window.setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      callbackRef.current();
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
};
